// AGC: Backend URL helper — environment-driven, no hardcoded URLs
import { Capacitor } from '@capacitor/core'

export const getBackendUrl = (): string => {
  // AGC: Capacitor native app (Android/iOS) always uses the configured backend URL.
  // AGC: WebView loads from capacitor://localhost, so we must bypass localhost logic.
  if (Capacitor.isNativePlatform()) {
    const url = import.meta.env.VITE_BACKEND_URL
    if (!url) throw new Error('VITE_BACKEND_URL is not configured. Check your .env.production or .env.developer file.')
    return url
  }

  const isDev = import.meta.env.DEV
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost'
  const isLocalNetworkAccess = hostname.startsWith('192.168.') ||
    hostname.startsWith('10.') ||
    hostname.startsWith('172.')

  if (isDev) {
    if (isLocalNetworkAccess) {
      const backendPort = import.meta.env.VITE_BACKEND_PORT || '3000'
      return `http://${hostname}:${backendPort}`
    }
    return import.meta.env.VITE_BACKEND_URL_DEV || 'http://localhost:3000'
  }

  // AGC: Production/developer builds — VITE_BACKEND_URL is set by .env.production or .env.developer
  const url = import.meta.env.VITE_BACKEND_URL
  if (!url) throw new Error('VITE_BACKEND_URL is not configured. Check your .env.production or .env.developer file.')
  return url
}
